import React from 'react';
import { AssetEntityIndex } from 'libs/types/src';

import { CONSTRUCTION_TYPE_OPTIONS, FIELD_PATHS } from '@funnels/constants';
import { useAnalytics } from '@funnels/providers';
import { run } from '@funnels/utils';

import { DropdownField } from '../../Fields';
import { DropdownFieldProps } from '../../Fields/DropdownField';
import { EditableViewProps } from '../types';

interface ConstructionTypeTeamViewProps
  extends EditableViewProps,
    AssetEntityIndex,
    Omit<DropdownFieldProps, 'name' | 'options'> {}

export const ConstructionTypeTeamView = (props: ConstructionTypeTeamViewProps) => {
  const { assetIndex = 0, onChange, ...rest } = props;
  const { tracking } = useAnalytics();

  const constructionTypeDropDownTracking = (selectedValues: string[]) => {
    const selectedValue = selectedValues[0];
    if (!selectedValue) return;
    const selection =
      CONSTRUCTION_TYPE_OPTIONS.find((option) => {
        return option.value === selectedValue;
      })?.label || '';
    tracking?.dropdown({ title: 'Construction type', selection, position: 'Property - Property Details' });
  };

  return (
    <DropdownField
      label={'Construction type'}
      name={FIELD_PATHS.ASSET_CONSTRUCTION_TYPE(assetIndex)}
      options={CONSTRUCTION_TYPE_OPTIONS}
      validationFailMessage="Please select the construction type"
      {...rest}
      onChange={run(constructionTypeDropDownTracking, onChange)}
    />
  );
};
